import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-db712972"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "kam-kam005" }
const _hoisted_2 = { class: "project-info-card" }
const _hoisted_3 = { class: "project-info-split" }
const _hoisted_4 = { class: "info-group main-group" }
const _hoisted_5 = { class: "info-row" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info-label" }, "Project:", -1))
const _hoisted_7 = { class: "info-val" }
const _hoisted_8 = { class: "info-row" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info-label" }, "Projectnummer:", -1))
const _hoisted_10 = { class: "info-val" }
const _hoisted_11 = { class: "info-row" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info-label" }, "Locatie:", -1))
const _hoisted_13 = { class: "info-val" }
const _hoisted_14 = { class: "info-row" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info-label" }, "Externe opdrachtgever:", -1))
const _hoisted_16 = { class: "info-val" }
const _hoisted_17 = { class: "info-group date-group" }
const _hoisted_18 = { class: "info-row" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info-label date-label" }, "Datum aangemaakt:", -1))
const _hoisted_20 = { class: "info-val" }
const _hoisted_21 = { class: "info-row" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info-label date-label" }, "Datum aangepast:", -1))
const _hoisted_23 = { class: "info-val" }
const _hoisted_24 = { class: "project-info-card" }
const _hoisted_25 = { class: "info-row" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info-label" }, "Projectleider:", -1))
const _hoisted_27 = { class: "info-val" }
const _hoisted_28 = { class: "info-row" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info-label" }, "Uitvoerder:", -1))
const _hoisted_30 = { class: "info-val" }
const _hoisted_31 = { class: "info-row" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info-label" }, "KAM-manager:", -1))
const _hoisted_33 = { class: "info-val" }
const _hoisted_34 = { class: "panel-header-content" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "panel-title" }, "1. Planvoorbereiding / Projectorganisatie", -1))
const _hoisted_36 = { class: "info-text" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Inleiding", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Dit VGM-plan heeft Arbowetgeving als basis. De onderwerpen veiligheid, gezondheid en milieu moeten in elke fase van het bouwproces onderwerp van gesprek zijn. Risico’s moeten op tijd geïnventariseerd en geëvalueerd worden. Vervolgens moeten passende maatregelen worden getroffen.", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Het bouwproces start in de initiatieffase en loopt door tot de onderhoudsfase. Behalve de directe werkgever van iedere individuele medewerker komen qua verantwoordelijkheden ook onder meer de opdrachtgever, de ontwerpende partij en de hoofdaannemer aan bod.", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Het VGM-plan beschrijft het geheel van maatregelen en procedures om de arbeidsomstandigheden zo goed mogelijk in te richten. Dit plan moet door alle werkgevers worden nageleefd; iedere werkgever is hiervoor zelf verantwoordelijk. Samenwerking is hierbij belangrijk, omdat meestal meerdere werkgever tegelijkertijd werkzaamheden verrichten.", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Bouwmethodiek "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Periode ontwerpfase "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Periode uitvoeringsfase "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Omschrijving project "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1))
const _hoisted_45 = { class: "panel-header-content" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "panel-title" }, "2. RI&E Initiatieffase", -1))
const _hoisted_47 = { class: "info-text" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Uitgevoerd met "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Datum "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1))
const _hoisted_50 = { class: "risk-item-header" }
const _hoisted_51 = {
  key: 1,
  class: "risk-subject-title"
}
const _hoisted_52 = {
  key: 0,
  class: "actions mt16"
}
const _hoisted_53 = { class: "panel-header-content" }
const _hoisted_54 = { class: "panel-title" }
const _hoisted_55 = { class: "info-text" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Uitgevoerd met "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Datum "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1))
const _hoisted_58 = { class: "risk-item-header" }
const _hoisted_59 = {
  key: 1,
  class: "risk-subject-title"
}
const _hoisted_60 = {
  key: 0,
  class: "actions mt16"
}
const _hoisted_61 = { class: "panel-header-content" }
const _hoisted_62 = { class: "panel-title" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-text" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Dit onderdeel heeft als doel om de voortgang met een VGM-bril te kijken en in te zoomen op de projectspecifieke risico’s in de uitvoeringsfase.")
], -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-text mt16" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Afspraken voor aanvang werkzaamheden"),
  /*#__PURE__*/_createElementVNode("p", null, "De projectleider is verantwoordelijk voor VGM-coördinatie. De vooral operationele taken die hierbij horen zijn gedelegeerd aan de uitvoerder. De uitvoerder houdt tijdig een startgesprek met de projectverantwoordelijke van iedere betrokken partij over de uit te voeren werkzaamheden. Het gaat dan om partijen wiens werkzaamheden invloed hebben op de veiligheids- en gezondheidsaspecten van zichzelf en anderen."),
  /*#__PURE__*/_createElementVNode("p", null, "Alle relevante partijen lopen de agenda van het startgesprek door, inclusief een screening op het VGM-plan. Waar nodig wordt het VGM-plan geactualiseerd. Andere plannen, behalve werkplannen, worden niet in behandeling genomen."),
  /*#__PURE__*/_createElementVNode("p", null, "De uitvoerder van de hoofdaannemer heeft een coördinerende rol. Daarbij wordt de uitvoerder eventueel gecoacht door Hoofd Uitvoering van de hoofdaannemer.")
], -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-text" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Hieronder volgt een opsomming van de collectieve risico’s, geïnventariseerd in de diverse fases. Risico’s die horen bij de individuele werkzaamheden van onderaannemers zijn hier buiten beschouwing. De onderaannemer neemt zelf initiatief tot het melden en onderbouwen van situaties die invloed hebben op collectieve factoren. Voor bijzondere risico’s en afwijkingen wordt zo nodig een TaakRisicoAnalyse (TRA) en / of werkplan opgesteld. Iedere werkgever neemt hierbij zelf het initiatief als er aanleiding voor is.")
], -1))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Uitgevoerd met "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Datum "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1))
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-text" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Iedere werkgever zorgt ervoor dat alle werknemers en door hem ingezette onderaannemers worden geïntroduceerd op de eerste dag dat zij op het werk komen. De werkgever zorgt voor projectrelevante voorlichting en instructie. Tevens wordt door hem regelmatig toolbox meetings verzorgd.")
], -1))
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-text" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Het materieel en handgereedschap dient zichtbaar recent (< 1 jaar geleden) gekeurd te zijn.")
], -1))
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-text" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Een aantal (bouw)materialen kan bij opslag, verwerking of afvoer schadelijk zijn voor de veiligheid of gezondheid van werknemers, derden of het milieu. Iedere werkgever is verantwoordelijk voor de vereiste voorlichting en instructie aan allen die in de omgeving van de betreffende werkzaamheden met het bedoelde materiaal werkzaam zijn. Deze voorlichting wordt ook aantoonbaar gemaakt.")
], -1))
const _hoisted_71 = { class: "info-text" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Voor bouwmaterialen geldt:", -1))
const _hoisted_73 = { class: "info-text" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Het afval zal zo veel mogelijk gescheiden worden verzameld. Op / bij elke container staat duidelijk aangegeven welk afval hierin moet worden gedeponeerd.", -1))
const _hoisted_75 = { key: 0 }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "no-mb" }, [
  /*#__PURE__*/_createElementVNode("strong", null, [
    /*#__PURE__*/_createTextVNode("De volgende soorten afval worden op de bouwplaats apart opgeslagen in de daarvoor bestemde container: "),
    /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
  ])
], -1))
const _hoisted_77 = { class: "waste-grid" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-text" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Onder- en nevenaannemers (en hun onderaannemers) zorgen zelf voor het scheiden, verzamelen en eventueel afvoeren van afval zoals overeengekomen is met de VGM-coördinator Uitvoeringsfase, tenzij van afwijkende afspraken sprake is. Praktische afstemming vindt plaats met de uitvoerder.")
], -1))
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-text" }, [
  /*#__PURE__*/_createElementVNode("p", null, "De registratie van afval met behulp van vrachtbrieven, afgiftebewijzen e.d. wordt verzorgd door iedere (onder-, neven-)aannemer zelf.")
], -1))
const _hoisted_80 = { class: "info-text" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "no-mb" }, [
  /*#__PURE__*/_createTextVNode("Geef hier aan welke BHV-middelen benodigd zijn en op welke locaties: "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1))
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-text" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Het dagelijks toezicht op veilig, gezond en milieubewust werken en de naleving van dit plan wordt uitgevoerd door de uitvoerder (1ste verantwoordelijke) van iedere werkgever (neven-, onder- en aannemer). Namens de hoofdaannemer worden periodieke werkplekinspecties uitgevoerd, vanuit verschillende rollen.")
], -1))
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-text" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Op afgesproken frequentie of zonder enige kennisgeving kunnen deskundigen het werk bezoeken. Er wordt gerapporteerd aan de projectbetrokkenen.")
], -1))
const _hoisted_84 = { class: "panel-header-content" }
const _hoisted_85 = { class: "panel-title" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-text" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Dit onderdeel heeft als doel om de VGM-beheersing op dit project te evalueren, zodat er lerend vermogen is richting andere projecten.")
], -1))
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Uitgevoerd met "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1))
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Datum "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1))
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*", -1))

import { computed, defineComponent, h, nextTick, ref, resolveComponent, watch } from 'vue'
import type { ComputedRef, PropType } from 'vue'
import { CheckOutlined, DeleteOutlined } from '@ant-design/icons-vue'
import kamStore from '@/stores/kam.ts'
import { parseISOToDayjs } from '@/helpers/dateUtils'
import {
  createDatePickerProxy,
  ensureArrayField,
  ensureBooleanMapField,
  ensureObjectField,
  mapPeopleToOptions,
  useConditionalRequiredFields,
  useDirtySnapshot
} from '@/helpers/kamFormUtils'
import type { PersonLikeOption, UnknownRecord } from '@/helpers/kamFormUtils'

type TextRow = Record<string, string>
type WasteKey = 'puin' | 'dakbedekking' | 'papierKarton' | 'overigPuin' | 'kca' | 'metalen' | 'schoonHout' | 'chemischAfval' | 'bouwSloopafval' | 'geverfdHout' | 'gips' | 'ldpe'
type EvaluationKey = 'risksFollowed' | 'improvements' | 'planningQualityVgm' | 'companyAttention' | 'dossierReady'
type ColumnDef = {
  key: string
  label: string
  tooltip?: string
  textarea?: boolean
  width?: string
  align?: 'left' | 'center' | 'right'
  minRows?: number
  placeholder?: string
  maxlength?: number
  uppercase?: boolean
}
type Answers = UnknownRecord & {
  externalClient?: boolean
  projectName?: string
  projectReference?: string
  projectLocation?: string
  createdDate?: string | Date | null
  updatedDate?: string | Date | null
  projectLeaderId?: number | string | null
  projectLeaderName?: string
  projectLeaderDate?: string | Date | null
  siteManagerId?: number | string | null
  siteManagerName?: string
  siteManagerDate?: string | Date | null
  kamManagerId?: number | string | null
  kamManagerName?: string
  kamManagerDate?: string | Date | null
  buildMethod?: string
  designPhasePeriod?: string
  executionPhasePeriod?: string
  projectDescription?: string
  initiationPerformedWith?: string
  initiationDate?: string | Date | null
  initiationRisks?: TextRow[]
  designPerformedWith?: string
  designDate?: string | Date | null
  designRisks?: TextRow[]
  collectiveRisksPerformedWith?: string
  collectiveRisksDate?: string | Date | null
  collectiveRisks?: TextRow[]
  bhvResources?: TextRow[]
  instructionNotes?: string
  equipmentNotes?: string
  materialNotes?: string
  wasteRemovalNotes?: string
  wasteRegistrationNotes?: string
  wasteStreams: Record<WasteKey, boolean>
  evaluation: Record<EvaluationKey, string>
  evaluationPerformedWith?: string
  evaluationDate?: string | Date | null
}


export default /*#__PURE__*/_defineComponent({
  __name: 'KAM005-v1',
  props: {
    answers: null,
    editable: { type: Boolean },
    projectLeaders: null,
    siteManagers: null,
    qualityManagement: null,
    employees: null,
    constructionWorkers: null
  },
  emits: ["dirty", "required-filled"],
  setup(__props: any, { emit }: { emit: ({(e: 'dirty', value: boolean): void, (e: 'required-filled', value: boolean): void }), expose: any, slots: any, attrs: any }) {

const props = __props as {
  answers: Answers
  editable: boolean
  projectLeaders?: PersonLikeOption[]
  siteManagers?: PersonLikeOption[]
  qualityManagement?: PersonLikeOption[]
  employees?: PersonLikeOption[]
  constructionWorkers?: PersonLikeOption[]
};

const WASTE_KEYS: WasteKey[] = ['puin', 'dakbedekking', 'papierKarton', 'overigPuin', 'kca', 'metalen', 'schoonHout', 'chemischAfval', 'bouwSloopafval', 'geverfdHout', 'gips', 'ldpe']



const saving = ref(false)
const formAnswers = computed(() => {
  const storeAnswers = kamStore().kamForm?.answers as Answers | undefined
  return (storeAnswers ?? props.answers ?? {}) as Answers
}) as ComputedRef<Answers>

const parties = computed(() => ensureArrayField<TextRow>(formAnswers.value, 'parties'))
const projectTeam = computed(() => ensureArrayField<TextRow>(formAnswers.value, 'projectTeam'))
const coordinationTasks = computed(() => ensureArrayField<TextRow>(formAnswers.value, 'coordinationTasks'))
const initiationRisks = computed(() => ensureArrayField<TextRow>(formAnswers.value, 'initiationRisks'))
const designRisks = computed(() => ensureArrayField<TextRow>(formAnswers.value, 'designRisks'))
const executionParties = computed(() => ensureArrayField<TextRow>(formAnswers.value, 'executionParties'))
const meetings = computed(() => ensureArrayField<TextRow>(formAnswers.value, 'meetings'))
const collectiveRisks = computed(() => ensureArrayField<TextRow>(formAnswers.value, 'collectiveRisks'))
const bhvResources = computed(() => ensureArrayField<TextRow>(formAnswers.value, 'bhvResources'))
const evaluationAnswers = computed(() => ensureObjectField<Record<EvaluationKey, string>>(formAnswers.value, 'evaluation'))

const initiationDateProxy = createDatePickerProxy(formAnswers, 'initiationDate', 'YYYY-MM-DD')
const designDateProxy = createDatePickerProxy(formAnswers, 'designDate', 'YYYY-MM-DD')
const collectiveRisksDateProxy = createDatePickerProxy(formAnswers, 'collectiveRisksDate', 'YYYY-MM-DD')
const evaluationDateProxy = createDatePickerProxy(formAnswers, 'evaluationDate', 'YYYY-MM-DD')

// Collapsible panels state: first section open by default
const activeCollapseKeys = ref<string[]>(['section-1'])

function getPeopleSource (propPeople?: PersonLikeOption[], filterKey?: string): PersonLikeOption[] {
  if (propPeople && propPeople.length > 0) return propPeople
  const filters = (kamStore().kamForm?.filters ?? {}) as Record<string, PersonLikeOption[]>
  if (filterKey && filters[filterKey] && Array.isArray(filters[filterKey])) {
    return filters[filterKey]
  }
  return []
}

const qualityManagementOptions = computed(() => {
  const source = getPeopleSource(props.qualityManagement, 'quality_management')
  const list = mapPeopleToOptions(source)
  if (!list.some(p => /henk/i.test(p.label))) {
    list.unshift({ id: 'henk-tijssen', label: 'Henk Tijssen' })
  }
  return list
})

const displayProjectLeader = computed(() => {
  if (formAnswers.value.projectLeaderName) return formAnswers.value.projectLeaderName
  const currentLeader = kamStore().kamForm?.project?.project_leader as { name?: string } | undefined
  return currentLeader?.name || '-'
})

const displaySiteManager = computed(() => {
  if (formAnswers.value.siteManagerName) return formAnswers.value.siteManagerName
  const currentManager = kamStore().kamForm?.project?.site_manager as { name?: string } | undefined
  return currentManager?.name || '-'
})

const displayKamManager = computed(() => {
  if (formAnswers.value.kamManagerName) return formAnswers.value.kamManagerName
  const defaultKam = qualityManagementOptions.value.find(p => /henk/i.test(p.label))
  return defaultKam?.label || 'Henk Tijssen'
})

function formatSignoffDate (dateVal: unknown): string {
  if (!dateVal) return ''
  const parsed = parseISOToDayjs(dateVal)
  return parsed ? parsed.format('DD-MM-YYYY') : String(dateVal)
}

const displayCreatedDate = computed(() => {
  const val = kamStore().kamForm?.created_at || formAnswers.value.createdDate
  return formatSignoffDate(val) || '-'
})

const displayUpdatedDate = computed(() => {
  const val = kamStore().kamForm?.updated_at || formAnswers.value.updatedDate
  return formatSignoffDate(val) || '-'
})

function hasText (val: unknown): boolean {
  return typeof val === 'string' && val.trim().length > 0
}

function cleanSubject (subject: string | undefined): string {
  return (subject || '').replace(/\s*\(aanvulling\)/i, '').trim().toLowerCase()
}

function findMatchingInitiationRisk (subject: string | undefined) {
  if (formAnswers.value.externalClient) return null
  const clean = cleanSubject(subject)
  if (!clean) return null
  const risks = initiationRisks.value || []
  return risks.find(r => cleanSubject(r.subject) === clean) || null
}

function isSharedWithInitiation (subject: string | undefined): boolean {
  return !!findMatchingInitiationRisk(subject)
}

function getInitiationDescription (subject: string | undefined): string {
  const match = findMatchingInitiationRisk(subject)
  return match?.description || ''
}

// Section progress calculations
const section1Progress = computed(() => {
  let filled = 0
  if (hasText(formAnswers.value.buildMethod)) filled++
  if (hasText(formAnswers.value.designPhasePeriod)) filled++
  if (hasText(formAnswers.value.executionPhasePeriod)) filled++
  if (hasText(formAnswers.value.projectDescription)) filled++
  return Math.round((filled / 4) * 100)
})

const section2Progress = computed(() => {
  if (formAnswers.value.externalClient) return 100
  let filled = 0
  if (hasText(formAnswers.value.initiationPerformedWith)) filled += 1
  if (formAnswers.value.initiationDate) filled += 1
  const risks = formAnswers.value.initiationRisks || []
  if (Array.isArray(risks) && risks.length > 0) {
    const risksFilled = risks.filter(r => hasText(r.description)).length
    const risksScore = Math.min(2, (risksFilled / risks.length) * 2)
    filled += risksScore
  } else {
    filled += 2
  }
  return Math.round((filled / 4) * 100)
})

const section3Progress = computed(() => {
  let filled = 0
  if (hasText(formAnswers.value.designPerformedWith)) filled += 1
  if (formAnswers.value.designDate) filled += 1
  const risks = formAnswers.value.designRisks || []
  if (Array.isArray(risks) && risks.length > 0) {
    const risksFilled = risks.filter(r => {
      if (isSharedWithInitiation(r.subject)) {
        return hasText(r.results)
      }
      return hasText(r.description) || hasText(r.results)
    }).length
    const risksScore = Math.min(2, (risksFilled / risks.length) * 2)
    filled += risksScore
  } else {
    filled += 2
  }
  return Math.round((filled / 4) * 100)
})

const section4Progress = computed(() => {
  let filled = 0
  if (hasText(formAnswers.value.collectiveRisksPerformedWith)) filled += 1
  if (formAnswers.value.collectiveRisksDate) filled += 1
  const bhv = formAnswers.value.bhvResources || []
  const bhvFilled = Array.isArray(bhv) && bhv.length > 0 && bhv.every(r => hasText(r.location))
  if (bhvFilled) filled += 1
  const waste = formAnswers.value.wasteStreams || ({} as Record<WasteKey, boolean>)
  const wasteSelected = Object.values(waste).some(v => v === true)
  if (wasteSelected) filled += 1
  return Math.round((filled / 4) * 100)
})

const section5Progress = computed(() => {
  let filled = 0
  if (hasText(formAnswers.value.evaluationPerformedWith)) filled += 1
  if (formAnswers.value.evaluationDate) filled += 1
  const evalMap = formAnswers.value.evaluation || ({} as Record<EvaluationKey, string>)
  let questionsFilled = 0
  evaluationQuestions.forEach(q => {
    if (hasText(evalMap[q.key])) questionsFilled++
  })
  const evalScore = (questionsFilled / 5) * 2
  filled += evalScore
  return Math.round((filled / 4) * 100)
})

const allRequiredFilled = computed(() => {
  if (formAnswers.value.externalClient) {
    return section1Progress.value === 100 && section3Progress.value === 100 && section4Progress.value === 100 && section5Progress.value === 100
  }
  return section1Progress.value === 100 && section2Progress.value === 100 && section3Progress.value === 100 && section4Progress.value === 100 && section5Progress.value === 100
})

const { capture } = useDirtySnapshot(formAnswers as ComputedRef<UnknownRecord>, value => emit('dirty', value))
useConditionalRequiredFields(() => allRequiredFilled.value, value => emit('required-filled', value))

const SectionBlock = defineComponent({
  name: 'SectionBlock',
  props: { title: { type: String, required: true } },
  setup (componentProps, { slots }) {
    const ACard = resolveComponent('a-card')
    return () => h(ACard, { size: 'small', class: 'mt16', title: componentProps.title }, { default: slots.default })
  }
})

const EditableTable = defineComponent({
  name: 'EditableTable',
  props: {
    title: { type: String, required: true },
    rows: { type: Array as PropType<TextRow[]>, required: true },
    columns: { type: Array as PropType<ColumnDef[]>, required: true },
    editable: { type: Boolean, required: true },
    legend: { type: String, default: '' }
  },
  emits: ['add', 'remove'],
  setup (componentProps, { emit: tableEmit }) {
    const ACard = resolveComponent('a-card')
    const ATextarea = resolveComponent('a-textarea')
    const AInput = resolveComponent('a-input')
    const AButton = resolveComponent('a-button')
    const APopconfirm = resolveComponent('a-popconfirm')
    const ATooltip = resolveComponent('a-tooltip')
    return () => h(ACard, { size: 'small', class: 'mt16', title: componentProps.title }, () => [
      h('div', { class: 'table-wrap' }, [
        h('table', { class: 'simple-table' }, [
          h('thead', [h('tr', [
            ...componentProps.columns.map(column => h('th', {
              style: {
                width: column.width ?? 'auto',
                textAlign: column.align ?? 'left'
              }
            }, [
              column.tooltip
                ? h(ATooltip, { title: column.tooltip, placement: 'top' }, { default: () => h('span', { class: 'col-header-tip' }, column.label) })
                : column.label
            ])),
            componentProps.editable ? h('th', { class: 'action-col' }) : null
          ])]),
          h('tbody', [
            ...componentProps.rows.map((row, rowIndex) => h('tr', { key: rowIndex }, [
              ...componentProps.columns.map(column => h('td', {
                style: {
                  textAlign: column.align ?? 'left',
                  verticalAlign: 'middle'
                }
              }, [
                column.textarea
                  ? h(ATextarea, {
                    value: row[column.key],
                    disabled: !componentProps.editable,
                    autoSize: { minRows: column.minRows ?? 1, maxRows: 6 },
                    placeholder: column.placeholder ?? '',
                    style: {
                      textAlign: column.align ?? 'left',
                      textTransform: column.uppercase ? 'uppercase' : 'none'
                    },
                    'onUpdate:value': (value: string) => { row[column.key] = value }
                  })
                  : h(AInput, {
                    value: row[column.key],
                    disabled: !componentProps.editable,
                    placeholder: column.placeholder ?? '',
                    maxlength: column.maxlength,
                    style: {
                      textAlign: column.align ?? 'left',
                      textTransform: column.uppercase ? 'uppercase' : 'none'
                    },
                    'onUpdate:value': (value: string) => { row[column.key] = value }
                  })
              ])),
              componentProps.editable ? h('td', { class: 'center action-col' }, [
                h(APopconfirm, {
                  title: 'Weet je zeker dat je deze regel wilt verwijderen?',
                  okText: 'Ja, verwijderen',
                  cancelText: 'Nee',
                  placement: 'bottomRight',
                  onConfirm: () => tableEmit('remove', rowIndex)
                }, {
                  default: () => h(AButton, { type: 'text', danger: true, title: 'Rij verwijderen' }, { icon: () => h(DeleteOutlined) })
                })
              ]) : null
            ])),
            componentProps.rows.length === 0 ? h('tr', [h('td', { class: 'muted', colspan: componentProps.columns.length + (componentProps.editable ? 1 : 0) }, 'Nog geen regels ingevuld.')]) : null
          ])
        ])
      ]),
      componentProps.legend ? h('div', { class: 'table-legend mt8' }, componentProps.legend) : null,
      componentProps.editable ? h('div', { class: 'actions' }, [h(AButton, { onClick: () => tableEmit('add') }, { default: () => 'Rij toevoegen' })]) : null
    ])
  }
})

const companyName = computed(() => {
  const entity = kamStore().kamForm?.project?.entity as { name?: string } | undefined
  return entity?.name?.replace(/\s+B\.?V\.?$/i, '') || 'Thunnissen'
})
const isThunnissen = computed(() => /thunnissen/i.test(companyName.value))
const chapterTwoIntro = computed(() => formAnswers.value.externalClient
  ? 'Dit onderdeel heeft als doel om de voortgang in relatie tot de RI&E Initiatieffase van de externe opdrachtgever te monitoren en om een check te doen op specifieke ontwerpaspecten en VGM-formaliteiten. De verantwoordelijkheid blijft bij de externe opdrachtgever.'
  : 'Dit onderdeel heeft als doel om al in de vroegste fase risico’s in beeld te brengen en hieraan maatregelen te koppelen conform de arbeidshygiënische strategie.')
const designIntro = computed(() => formAnswers.value.externalClient
  ? 'Dit onderdeel heeft als doel om de voortgang in relatie tot de “Monitor RI&E Initiatieffase van de externe opdrachtgever” en om een check te doen op specifieke ontwerpaspecten en VGM-formaliteiten.'
  : 'Dit onderdeel heeft als doel om de voortgang met een VGM-bril te bekijken en een check te doen op de ontwerpstukken, zodat eventuele wijzigingen op tijd doorgevoerd kunnen worden.')

const partyColumns: ColumnDef[] = [{ key: 'role', label: 'Rol', width: '22%' }, { key: 'name', label: 'Naam' }, { key: 'address', label: 'Adres' }, { key: 'city', label: 'Postcode/Plaats' }, { key: 'contact', label: 'Contactpersoon' }, { key: 'phone', label: 'Telefoon' }]
const projectTeamColumns: ColumnDef[] = [{ key: 'role', label: 'Rol', width: '35%' }, { key: 'name', label: 'Naam' }]
const coordinationColumns: ColumnDef[] = [
  { key: 'phase', label: 'Fase', width: '135px', placeholder: 'Fase...' },
  { key: 'task', label: 'Taak', textarea: true, minRows: 1, placeholder: 'Taakomschrijving...' },
  { key: 'kam', label: 'KAM', width: '46px', align: 'center', maxlength: 4, uppercase: true, tooltip: 'KAM-manager' },
  { key: 'ow', label: 'OW', width: '46px', align: 'center', maxlength: 4, uppercase: true, tooltip: 'Ontwikkelaar' },
  { key: 'pv', label: 'PV', width: '46px', align: 'center', maxlength: 4, uppercase: true, tooltip: 'Planvoorbereider' },
  { key: 'pl', label: 'PL', width: '46px', align: 'center', maxlength: 4, uppercase: true, tooltip: 'Projectleider' },
  { key: 'wv', label: 'WV', width: '46px', align: 'center', maxlength: 4, uppercase: true, tooltip: 'Werkvoorbereider' },
  { key: 'uit', label: 'UIT', width: '46px', align: 'center', maxlength: 4, uppercase: true, tooltip: 'Uitvoerder' },
  { key: 'oa', label: 'OA', width: '46px', align: 'center', maxlength: 4, uppercase: true, tooltip: 'Onderaannemer' }
]
const meetingColumns: ColumnDef[] = [
  { key: 'number', label: '#', width: '50px', align: 'center' },
  { key: 'name', label: 'Naam vergadering', width: '22%' },
  { key: 'frequency', label: 'Frequentie', width: '18%' },
  { key: 'participants', label: 'Deelnemers' },
  { key: 'minutesBy', label: 'Notulen door', width: '18%' }
]
const collectiveRiskColumns: ColumnDef[] = [
  { key: 'risk', label: 'Gesignaleerd risico', width: '26%' },
  { key: 'measure', label: 'Maatregel', textarea: true, minRows: 1 },
  { key: 'installedBy', label: 'Aanbrengen door', width: '18%' },
  { key: 'maintainedBy', label: 'In stand houden door', width: '18%' }
]
const bhvColumns: ColumnDef[] = [{ key: 'type', label: 'Type BHV-middelen' }, { key: 'location', label: 'Locaties' }]
const wasteOptions = [
  { key: 'puin' as WasteKey, label: 'Puin' }, { key: 'dakbedekking' as WasteKey, label: 'Dakbedekking' }, { key: 'papierKarton' as WasteKey, label: 'Papier en karton' }, { key: 'overigPuin' as WasteKey, label: 'Overig puin (en zand)' }, { key: 'kca' as WasteKey, label: 'Klein chemisch afval (KCA)' }, { key: 'metalen' as WasteKey, label: 'Metalen' }, { key: 'schoonHout' as WasteKey, label: 'Schoon hout' }, { key: 'chemischAfval' as WasteKey, label: 'Overig chemisch afval' }, { key: 'bouwSloopafval' as WasteKey, label: 'Overig ongesorteerd bouwafval' }, { key: 'geverfdHout' as WasteKey, label: 'Overig (geverfd) hout' }, { key: 'gips' as WasteKey, label: 'Gips' }, { key: 'ldpe' as WasteKey, label: 'LDPE folie' }
]
const environmentRules = ['In de juiste hoeveelheden afroepen;', 'Zo mogelijk op maat gemaakt (en geleverd);', 'Op de juiste wijze opslaan;', 'Beschermd tegen vocht, weersinvloeden, beschadiging en ontstekingsbronnen;', 'Breuk en afkeur wordt zoveel mogelijk hergebruikt of verkocht;', 'Bruikbare materiaalresten worden zoveel mogelijk hergebruikt of verkocht;', 'Restanten van betonproducten worden van het terrein afgevoerd naar een stortplaats of steenbreker;', 'Europallets worden door de leverancier retour genomen;', 'Overslag, aftappen of overgieten van schadelijke vloeistoffen gebeurt boven een bak;', 'Morsverliezen worden meteen opgeruimd met behulp van absorptiekorrels;', 'Reiniging van gereedschappen gebeurt in spoelbakken geschikt voor verf- en oplosmiddelen;', 'Overlast voor omwonenden wordt zoveel mogelijk beperkt;', 'Van bepaalde belastende activiteiten worden omwonenden vooraf op de hoogte gebracht;', 'Orde en netheid op de bouwplaats worden gehandhaafd.']
const evaluationQuestions = [
  { key: 'risksFollowed' as EvaluationKey, label: 'Welke risico’s zijn op tijd geïnventariseerd en op de juiste manier opgevolgd?' },
  { key: 'improvements' as EvaluationKey, label: 'Op welke punten zijn verbeteringen mogelijk qua risico-inschatting en -opvolging' },
  { key: 'planningQualityVgm' as EvaluationKey, label: 'Hoe was de verhouding planning – kwaliteit – VGM?' },
  { key: 'companyAttention' as EvaluationKey, label: 'Zijn er aspecten die ook bedrijfsbreed aandacht moeten hebben?' },
  { key: 'dossierReady' as EvaluationKey, label: 'Zijn de overall projectevaluaties en het VGM-dossier (onderhoudsfase) opgesteld?' }
]

watch(() => kamStore().kamForm, async newForm => {
  if (!newForm) return
  if (!newForm.answers || Array.isArray(newForm.answers)) newForm.answers = {}
  const answers = newForm.answers as Answers
  const project = newForm.project as { reference?: string, name?: string, city?: string, project_leader?: { id: number | string, name?: string }, site_manager?: { id: number | string, name?: string } } | undefined
  if (answers.externalClient == null) answers.externalClient = false
  if (!answers.projectReference && project?.reference) answers.projectReference = project.reference
  if (!answers.projectName && project?.name) answers.projectName = project.name
  if (!answers.projectLocation && project?.city) answers.projectLocation = project.city
  if (!answers.createdDate) answers.createdDate = new Date().toISOString()
  if (!answers.updatedDate) answers.updatedDate = new Date().toISOString()
  if (!answers.projectLeaderName && project?.project_leader?.name) {
    answers.projectLeaderName = project.project_leader.name
    answers.projectLeaderId = project.project_leader.id
  }
  if (!answers.siteManagerName && project?.site_manager?.name) {
    answers.siteManagerName = project.site_manager.name
    answers.siteManagerId = project.site_manager.id
  }
  if (!answers.kamManagerName) {
    const defaultKam = qualityManagementOptions.value.find(p => /henk/i.test(p.label))
    answers.kamManagerName = defaultKam?.label || 'Henk Tijssen'
    if (defaultKam) answers.kamManagerId = defaultKam.id
  }
  ensureBooleanMapField(answers, 'wasteStreams', WASTE_KEYS)
  ensureObjectField<Record<EvaluationKey, string>>(answers, 'evaluation')
  seedDefaults()
  await nextTick()
  capture(newForm.answers ?? {})
}, { immediate: true })

function seedDefaults () {
  if (!parties.value.length) parties.value.push(emptyParty('Opdrachtgever'), emptyParty('VGM-coördinator ontwerpfase'), emptyParty('VGM-coördinator uitvoeringsfase'), emptyParty('Overige'))
  if (!projectTeam.value.length) projectTeam.value.push(...['Projectontwikkelaar', 'Planvoorbereider', 'Werkvoorbereider', 'Projectleider', 'Uitvoerder'].map(role => ({ role, name: '' })))
  if (!coordinationTasks.value.length) {
    coordinationTasks.value.push(
      task('Initiatieffase', 'Start de opbouw van het VGM-plan.', 'RA', 'I', 'CI', 'CS', '', '', ''),
      task('Ontwerpfase', 'Vervolgt de opbouw van het VGM-plan.', 'RA', '', 'C', 'C', 'S', 'I', ''),
      task('Ontwerpfase', 'Vraagt VGM-documenten op (indien andere opdrachtgever).', 'C', 'I', 'C', 'RA', 'S', '', ''),
      task('Uitvoeringsfase', 'Vervolgt de opbouw van het VGM-plan.', 'RA', '', '', 'C', 'S', 'I', '')
    )
  }
  if (!initiationRisks.value.length) {
    initiationRisks.value.push(...['Transportroutes', 'Belendingen', 'Bodem/ondergrond', 'Bouwterrein'].map(subject => ({ subject, description: '' })))
  }
  if (!designRisks.value.length) {
    designRisks.value.push(...['Transportroutes', 'Belendingen', 'Bodem/ondergrond', 'Bouwterrein', 'Bouwsysteem', 'Fysieke belasting', 'Gevaarlijke stoffen', 'Gevels', 'Daken', 'Kruipruimtes', 'VGM-dossier aangemaakt?'].map(subject => ({ subject, description: '', results: '' })))
  }
  if (!meetings.value.length) {
    meetings.value.push(
      { number: '1', name: 'Bouwvergadering', frequency: 'Maandelijks', participants: 'PL, UIT, opdrachtgever', minutesBy: 'Directievoering / Opdrachtgever' },
      { number: '2', name: 'Interne werkbespreking', frequency: '2-wekelijks', participants: 'PL, UIT, WV, genodigden', minutesBy: 'WV' },
      { number: '3', name: 'Werkvergadering', frequency: '2-wekelijks', participants: 'PL, UIT, WV, onderaannemers (en nevenaannemers)', minutesBy: 'WV' },
      { number: '4', name: 'Coördinatie-overleg', frequency: 'Naar behoeft', participants: 'PL, UIT, NUTS', minutesBy: 'UIT' },
      { number: '5', name: '10 Min. overleg', frequency: '5x per week is basis, evt. min 2x per week', participants: 'Voorlieden/UIT TB/etc.', minutesBy: 'UIT / White Board' },
      { number: '6', name: 'VGM-ronde KAM', frequency: 'Op basis inschatting Hier frequentie invullen', participants: 'KAM-manager, PL, WV, UIT', minutesBy: 'KAM-manager' }
    )
  }
  if (!collectiveRisks.value.length) collectiveRisks.value.push({ risk: 'Vanuit BLVC-plan', measure: '', installedBy: '', maintainedBy: '' }, { risk: 'Koppeling startgesprek', measure: '', installedBy: '', maintainedBy: '' })
  if (!bhvResources.value.length) bhvResources.value.push({ type: 'Brandblusser', location: '' }, { type: 'AED', location: '' }, { type: 'Oogspoelmiddel', location: '' })
}

function emptyParty (role = '') { return { role, name: '', address: '', city: '', contact: '', phone: '' } }
function task (phase: string, task: string, kam: string, ow: string, pv: string, pl: string, wv: string, uit: string, oa: string) { return { phase, task, kam, ow, pv, pl, wv, uit, oa } }
function addParty () { parties.value.push(emptyParty()) }
function removeParty (index: number) { parties.value.splice(index, 1) }
function addProjectTeam () { projectTeam.value.push({ role: '', name: '' }) }
function removeProjectTeam (index: number) { projectTeam.value.splice(index, 1) }
function addCoordinationTask () { coordinationTasks.value.push(task('', '', '', '', '', '', '', '', '')) }
function removeCoordinationTask (index: number) { coordinationTasks.value.splice(index, 1) }
function addInitiationRisk () { initiationRisks.value.push({ subject: '', description: '' }) }
function removeInitiationRisk (index: number) { initiationRisks.value.splice(index, 1) }
function addDesignRisk () { designRisks.value.push({ subject: '', description: '', results: '' }) }
function removeDesignRisk (index: number) { designRisks.value.splice(index, 1) }
function addExecutionParty () { executionParties.value.push(emptyParty()) }
function removeExecutionParty (index: number) { executionParties.value.splice(index, 1) }
function addMeeting () { meetings.value.push({ number: String(meetings.value.length + 1), name: '', frequency: '', participants: '', minutesBy: '' }) }
function removeMeeting (index: number) { meetings.value.splice(index, 1) }
function addCollectiveRisk () { collectiveRisks.value.push({ risk: '', measure: '', installedBy: '', maintainedBy: '' }) }
function removeCollectiveRisk (index: number) { collectiveRisks.value.splice(index, 1) }
function addBhvResource () { bhvResources.value.push({ type: '', location: '' }) }
function removeBhvResource (index: number) { bhvResources.value.splice(index, 1) }

return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_collapse = _resolveComponent("a-collapse")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_card, {
      class: "mt16",
      loading: saving.value,
      title: "KAM005 - VGM-plan"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_card, {
          size: "small",
          title: "Project en akkoord",
          class: "project-header-card"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_row, { gutter: [24, 16] }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, {
                  xs: 24,
                  lg: 12
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                          _createElementVNode("div", _hoisted_5, [
                            _hoisted_6,
                            _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(formAnswers).projectName || '-'), 1)
                          ]),
                          _createElementVNode("div", _hoisted_8, [
                            _hoisted_9,
                            _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(formAnswers).projectReference || '-'), 1)
                          ]),
                          _createElementVNode("div", _hoisted_11, [
                            _hoisted_12,
                            _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(formAnswers).projectLocation || '-'), 1)
                          ]),
                          _createElementVNode("div", _hoisted_14, [
                            _hoisted_15,
                            _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(formAnswers).externalClient ? 'Ja' : 'Nee'), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            _hoisted_19,
                            _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(displayCreatedDate)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_21, [
                            _hoisted_22,
                            _createElementVNode("span", _hoisted_23, _toDisplayString(_unref(displayUpdatedDate)), 1)
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, {
                  xs: 24,
                  lg: 12
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _hoisted_26,
                        _createElementVNode("span", _hoisted_27, _toDisplayString(_unref(displayProjectLeader)), 1),
                        _createVNode(_component_a_tag, {
                          color: _unref(formAnswers).projectLeaderDate ? 'success' : 'default',
                          class: "signoff-tag"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(formAnswers).projectLeaderDate ? `Gezien op ${formatSignoffDate(_unref(formAnswers).projectLeaderDate)}` : 'Nog niet gezien'), 1)
                          ]),
                          _: 1
                        }, 8, ["color"])
                      ]),
                      _createElementVNode("div", _hoisted_28, [
                        _hoisted_29,
                        _createElementVNode("span", _hoisted_30, _toDisplayString(_unref(displaySiteManager)), 1),
                        _createVNode(_component_a_tag, {
                          color: _unref(formAnswers).siteManagerDate ? 'success' : 'default',
                          class: "signoff-tag"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(formAnswers).siteManagerDate ? `Gezien op ${formatSignoffDate(_unref(formAnswers).siteManagerDate)}` : 'Nog niet gezien'), 1)
                          ]),
                          _: 1
                        }, 8, ["color"])
                      ]),
                      _createElementVNode("div", _hoisted_31, [
                        _hoisted_32,
                        _createElementVNode("span", _hoisted_33, _toDisplayString(_unref(displayKamManager)), 1),
                        _createVNode(_component_a_tag, {
                          color: _unref(formAnswers).kamManagerDate ? 'success' : 'default',
                          class: "signoff-tag"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(formAnswers).kamManagerDate ? `Gezien op ${formatSignoffDate(_unref(formAnswers).kamManagerDate)}` : 'Nog niet gezien'), 1)
                          ]),
                          _: 1
                        }, 8, ["color"])
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_collapse, {
          activeKey: activeCollapseKeys.value,
          "onUpdate:activeKey": _cache[17] || (_cache[17] = ($event: any) => ((activeCollapseKeys).value = $event)),
          class: "vgm-collapse mt16",
          bordered: false
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_collapse_panel, { key: "section-1" }, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_34, [
                  _hoisted_35,
                  _createVNode(_component_a_tag, {
                    color: _unref(section1Progress) === 100 ? 'success' : 'processing',
                    class: "panel-progress-tag"
                  }, {
                    default: _withCtx(() => [
                      (_unref(section1Progress) === 100)
                        ? (_openBlock(), _createBlock(_unref(CheckOutlined), { key: 0 }))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(_unref(section1Progress)) + "% ", 1)
                    ]),
                    _: 1
                  }, 8, ["color"])
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_36, [
                  _hoisted_37,
                  _hoisted_38,
                  _hoisted_39,
                  _createElementVNode("p", null, _toDisplayString(_unref(companyName)) + " neemt regelmatig meerdere van deze rollen in een bouwproject op zich. Om deze reden is gekozen voor een structuur waarbij vanuit één VGM-plan gewerkt wordt waarin de diverse fases actief gemonitord worden.", 1),
                  _hoisted_40
                ]),
                _createVNode(_unref(SectionBlock), { title: "Projectgegevens" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_row, { gutter: [16, 12] }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, {
                          xs: 24,
                          md: 8
                        }, {
                          default: _withCtx(() => [
                            _hoisted_41,
                            _createVNode(_component_a_input, {
                              value: _unref(formAnswers).buildMethod,
                              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formAnswers).buildMethod) = $event)),
                              disabled: !__props.editable,
                              placeholder: "bijv. Traditioneel / Tunnelbouw"
                            }, null, 8, ["value", "disabled"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, {
                          xs: 24,
                          md: 8
                        }, {
                          default: _withCtx(() => [
                            _hoisted_42,
                            _createVNode(_component_a_input, {
                              value: _unref(formAnswers).designPhasePeriod,
                              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_unref(formAnswers).designPhasePeriod) = $event)),
                              disabled: !__props.editable,
                              placeholder: "bijv. Q1 2026 - Q3 2026"
                            }, null, 8, ["value", "disabled"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, {
                          xs: 24,
                          md: 8
                        }, {
                          default: _withCtx(() => [
                            _hoisted_43,
                            _createVNode(_component_a_input, {
                              value: _unref(formAnswers).executionPhasePeriod,
                              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_unref(formAnswers).executionPhasePeriod) = $event)),
                              disabled: !__props.editable,
                              placeholder: "bijv. Q4 2026 - Q4 2027"
                            }, null, 8, ["value", "disabled"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _hoisted_44,
                            _createVNode(_component_a_textarea, {
                              value: _unref(formAnswers).projectDescription,
                              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_unref(formAnswers).projectDescription) = $event)),
                              disabled: !__props.editable,
                              "auto-size": { minRows: 3 },
                              placeholder: "Korte toelichting op het project..."
                            }, null, 8, ["value", "disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(EditableTable), {
                  title: "Betrokken partijen",
                  rows: _unref(parties),
                  columns: partyColumns,
                  editable: __props.editable,
                  onAdd: addParty,
                  onRemove: removeParty
                }, null, 8, ["rows", "editable"]),
                _createVNode(_unref(EditableTable), {
                  title: "Projectteam",
                  rows: _unref(projectTeam),
                  columns: projectTeamColumns,
                  editable: __props.editable,
                  onAdd: addProjectTeam,
                  onRemove: removeProjectTeam
                }, null, 8, ["rows", "editable"]),
                _createVNode(_unref(EditableTable), {
                  title: "VGM-coördinatietaken",
                  rows: _unref(coordinationTasks),
                  columns: coordinationColumns,
                  editable: __props.editable,
                  legend: "RACI-matrix: R = Verantwoordelijk, A = Eindverantwoordelijk, C = Geraadpleegd, I = Geïnformeerd, S = Ondersteunend (beweeg over de kolomkoppen voor de rolbenaming)",
                  onAdd: addCoordinationTask,
                  onRemove: removeCoordinationTask
                }, null, 8, ["rows", "editable"])
              ]),
              _: 1
            }),
            (!_unref(formAnswers).externalClient)
              ? (_openBlock(), _createBlock(_component_a_collapse_panel, { key: "section-2" }, {
                  header: _withCtx(() => [
                    _createElementVNode("div", _hoisted_45, [
                      _hoisted_46,
                      _createVNode(_component_a_tag, {
                        color: _unref(section2Progress) === 100 ? 'success' : 'processing',
                        class: "panel-progress-tag"
                      }, {
                        default: _withCtx(() => [
                          (_unref(section2Progress) === 100)
                            ? (_openBlock(), _createBlock(_unref(CheckOutlined), { key: 0 }))
                            : _createCommentVNode("", true),
                          _createTextVNode(" " + _toDisplayString(_unref(section2Progress)) + "% ", 1)
                        ]),
                        _: 1
                      }, 8, ["color"])
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_47, [
                      _createElementVNode("p", null, _toDisplayString(_unref(chapterTwoIntro)), 1)
                    ]),
                    _createVNode(_component_a_row, {
                      gutter: [16, 12],
                      class: "mb16"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, {
                          xs: 24,
                          md: 12
                        }, {
                          default: _withCtx(() => [
                            _hoisted_48,
                            _createVNode(_component_a_input, {
                              value: _unref(formAnswers).initiationPerformedWith,
                              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_unref(formAnswers).initiationPerformedWith) = $event)),
                              disabled: !__props.editable,
                              placeholder: "Namen betrokken personen"
                            }, null, 8, ["value", "disabled"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, {
                          xs: 24,
                          md: 12
                        }, {
                          default: _withCtx(() => [
                            _hoisted_49,
                            _createVNode(_component_a_date_picker, {
                              value: _unref(initiationDateProxy),
                              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => (_isRef(initiationDateProxy) ? (initiationDateProxy).value = $event : null)),
                              disabled: !__props.editable,
                              format: "DD-MM-YYYY",
                              "value-format": "YYYY-MM-DD",
                              style: {"width":"100%"}
                            }, null, 8, ["value", "disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(SectionBlock), { title: "Onderwerpen initiatieffase" }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(initiationRisks), (row, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: "risk-item-block"
                          }, [
                            _createElementVNode("div", _hoisted_50, [
                              (__props.editable)
                                ? (_openBlock(), _createBlock(_component_a_input, {
                                    key: 0,
                                    value: row.subject,
                                    "onUpdate:value": ($event: any) => ((row.subject) = $event),
                                    placeholder: "Onderwerp...",
                                    style: {"width":"280px","font-weight":"600"}
                                  }, null, 8, ["value", "onUpdate:value"]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_51, _toDisplayString(row.subject), 1)),
                              (__props.editable)
                                ? (_openBlock(), _createBlock(_component_a_popconfirm, {
                                    key: 2,
                                    placement: "bottomRight",
                                    title: "Weet je zeker dat je dit onderwerp wilt verwijderen?",
                                    "ok-text": "Ja, verwijderen",
                                    "cancel-text": "Nee",
                                    onConfirm: ($event: any) => (removeInitiationRisk(index))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_button, {
                                        type: "text",
                                        danger: "",
                                        title: "Onderwerp verwijderen"
                                      }, {
                                        icon: _withCtx(() => [
                                          _createVNode(_unref(DeleteOutlined))
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 2
                                  }, 1032, ["onConfirm"]))
                                : _createCommentVNode("", true)
                            ]),
                            _createVNode(_component_a_row, { gutter: 16 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_col, {
                                  xs: 24,
                                  md: 12
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_textarea, {
                                      value: row.description,
                                      "onUpdate:value": ($event: any) => ((row.description) = $event),
                                      disabled: !__props.editable,
                                      "auto-size": { minRows: 2, maxRows: 6 },
                                      placeholder: "Beschrijving en maatregelen..."
                                    }, null, 8, ["value", "onUpdate:value", "disabled"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ]))
                        }), 128)),
                        (__props.editable)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                              _createVNode(_component_a_button, { onClick: addInitiationRisk }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Onderwerp toevoegen")
                                ]),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_a_collapse_panel, { key: "section-3" }, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("span", _hoisted_54, _toDisplayString((_unref(formAnswers).externalClient ? '2' : '3') + '. RI&E Ontwerpfase'), 1),
                  _createVNode(_component_a_tag, {
                    color: _unref(section3Progress) === 100 ? 'success' : 'processing',
                    class: "panel-progress-tag"
                  }, {
                    default: _withCtx(() => [
                      (_unref(section3Progress) === 100)
                        ? (_openBlock(), _createBlock(_unref(CheckOutlined), { key: 0 }))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(_unref(section3Progress)) + "% ", 1)
                    ]),
                    _: 1
                  }, 8, ["color"])
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("p", null, _toDisplayString(_unref(designIntro)), 1)
                ]),
                _createVNode(_component_a_row, {
                  gutter: [16, 12],
                  class: "mb16"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, {
                      xs: 24,
                      md: 12
                    }, {
                      default: _withCtx(() => [
                        _hoisted_56,
                        _createVNode(_component_a_input, {
                          value: _unref(formAnswers).designPerformedWith,
                          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_unref(formAnswers).designPerformedWith) = $event)),
                          disabled: !__props.editable,
                          placeholder: "Namen betrokken personen"
                        }, null, 8, ["value", "disabled"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, {
                      xs: 24,
                      md: 12
                    }, {
                      default: _withCtx(() => [
                        _hoisted_57,
                        _createVNode(_component_a_date_picker, {
                          value: _unref(designDateProxy),
                          "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => (_isRef(designDateProxy) ? (designDateProxy).value = $event : null)),
                          disabled: !__props.editable,
                          format: "DD-MM-YYYY",
                          "value-format": "YYYY-MM-DD",
                          style: {"width":"100%"}
                        }, null, 8, ["value", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(SectionBlock), { title: "Onderwerpen ontwerpfase" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(designRisks), (row, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "risk-item-block"
                      }, [
                        _createElementVNode("div", _hoisted_58, [
                          (__props.editable)
                            ? (_openBlock(), _createBlock(_component_a_input, {
                                key: 0,
                                value: row.subject,
                                "onUpdate:value": ($event: any) => ((row.subject) = $event),
                                placeholder: "Onderwerp...",
                                style: {"width":"280px","font-weight":"600"}
                              }, null, 8, ["value", "onUpdate:value"]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_59, _toDisplayString(row.subject), 1)),
                          (__props.editable)
                            ? (_openBlock(), _createBlock(_component_a_popconfirm, {
                                key: 2,
                                placement: "bottomRight",
                                title: "Weet je zeker dat je dit onderwerp wilt verwijderen?",
                                "ok-text": "Ja, verwijderen",
                                "cancel-text": "Nee",
                                onConfirm: ($event: any) => (removeDesignRisk(index))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_button, {
                                    type: "text",
                                    danger: "",
                                    title: "Onderwerp verwijderen"
                                  }, {
                                    icon: _withCtx(() => [
                                      _createVNode(_unref(DeleteOutlined))
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 2
                              }, 1032, ["onConfirm"]))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode(_component_a_row, { gutter: 16 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_col, {
                              xs: 24,
                              md: 12
                            }, {
                              default: _withCtx(() => [
                                (isSharedWithInitiation(row.subject))
                                  ? (_openBlock(), _createBlock(_component_a_textarea, {
                                      key: 0,
                                      value: getInitiationDescription(row.subject),
                                      disabled: "",
                                      "auto-size": { minRows: 2, maxRows: 6 },
                                      placeholder: "Overgenomen uit initiatieffase (nog niet ingevuld)",
                                      title: "Overgenomen uit initiatieffase (alleen-lezen)"
                                    }, null, 8, ["value"]))
                                  : (_openBlock(), _createBlock(_component_a_textarea, {
                                      key: 1,
                                      value: row.description,
                                      "onUpdate:value": ($event: any) => ((row.description) = $event),
                                      disabled: !__props.editable,
                                      "auto-size": { minRows: 2, maxRows: 6 },
                                      placeholder: "Beschrijving en maatregelen..."
                                    }, null, 8, ["value", "onUpdate:value", "disabled"]))
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_a_col, {
                              xs: 24,
                              md: 12
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_textarea, {
                                  value: row.results,
                                  "onUpdate:value": ($event: any) => ((row.results) = $event),
                                  disabled: !__props.editable,
                                  "auto-size": { minRows: 2, maxRows: 6 },
                                  placeholder: "Resultaten..."
                                }, null, 8, ["value", "onUpdate:value", "disabled"])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]))
                    }), 128)),
                    (__props.editable)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                          _createVNode(_component_a_button, { onClick: addDesignRisk }, {
                            default: _withCtx(() => [
                              _createTextVNode("Onderwerp toevoegen")
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_collapse_panel, { key: "section-4" }, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_61, [
                  _createElementVNode("span", _hoisted_62, _toDisplayString((_unref(formAnswers).externalClient ? '3' : '4') + '. RI&E en afsprakenoverzicht Uitvoeringsfase'), 1),
                  _createVNode(_component_a_tag, {
                    color: _unref(section4Progress) === 100 ? 'success' : 'processing',
                    class: "panel-progress-tag"
                  }, {
                    default: _withCtx(() => [
                      (_unref(section4Progress) === 100)
                        ? (_openBlock(), _createBlock(_unref(CheckOutlined), { key: 0 }))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(_unref(section4Progress)) + "% ", 1)
                    ]),
                    _: 1
                  }, 8, ["color"])
                ])
              ]),
              default: _withCtx(() => [
                _hoisted_63,
                _createVNode(_unref(EditableTable), {
                  title: "Betrokken partijen (aanvulling)",
                  rows: _unref(executionParties),
                  columns: partyColumns,
                  editable: __props.editable,
                  onAdd: addExecutionParty,
                  onRemove: removeExecutionParty
                }, null, 8, ["rows", "editable"]),
                _hoisted_64,
                _createVNode(_unref(EditableTable), {
                  title: "Vergaderingen met VGM als vast agendapunt",
                  rows: _unref(meetings),
                  columns: meetingColumns,
                  editable: __props.editable,
                  onAdd: addMeeting,
                  onRemove: removeMeeting
                }, null, 8, ["rows", "editable"]),
                _createVNode(_unref(SectionBlock), { title: "Collectieve risico’s uitvoeringsfase" }, {
                  default: _withCtx(() => [
                    _hoisted_65,
                    _createVNode(_component_a_row, { gutter: [16, 12] }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, {
                          xs: 24,
                          md: 12
                        }, {
                          default: _withCtx(() => [
                            _hoisted_66,
                            _createVNode(_component_a_input, {
                              value: _unref(formAnswers).collectiveRisksPerformedWith,
                              "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_unref(formAnswers).collectiveRisksPerformedWith) = $event)),
                              disabled: !__props.editable,
                              placeholder: "Namen betrokken personen"
                            }, null, 8, ["value", "disabled"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, {
                          xs: 24,
                          md: 12
                        }, {
                          default: _withCtx(() => [
                            _hoisted_67,
                            _createVNode(_component_a_date_picker, {
                              value: _unref(collectiveRisksDateProxy),
                              "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => (_isRef(collectiveRisksDateProxy) ? (collectiveRisksDateProxy).value = $event : null)),
                              disabled: !__props.editable,
                              format: "DD-MM-YYYY",
                              "value-format": "YYYY-MM-DD",
                              style: {"width":"100%"}
                            }, null, 8, ["value", "disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(EditableTable), {
                      title: "Collectieve risico’s",
                      rows: _unref(collectiveRisks),
                      columns: collectiveRiskColumns,
                      editable: __props.editable,
                      onAdd: addCollectiveRisk,
                      onRemove: removeCollectiveRisk
                    }, null, 8, ["rows", "editable"])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(SectionBlock), { title: "Voorlichting en instructie aan de werknemers" }, {
                  default: _withCtx(() => [
                    _hoisted_68,
                    _createVNode(_component_a_textarea, {
                      value: _unref(formAnswers).instructionNotes,
                      "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_unref(formAnswers).instructionNotes) = $event)),
                      disabled: !__props.editable,
                      "auto-size": { minRows: 2 },
                      placeholder: "Eventuele aanvullende notities..."
                    }, null, 8, ["value", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(SectionBlock), { title: "Materieel" }, {
                  default: _withCtx(() => [
                    _hoisted_69,
                    _createVNode(_component_a_textarea, {
                      value: _unref(formAnswers).equipmentNotes,
                      "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_unref(formAnswers).equipmentNotes) = $event)),
                      disabled: !__props.editable,
                      "auto-size": { minRows: 2 },
                      placeholder: "Eventuele aanvullende notities..."
                    }, null, 8, ["value", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(SectionBlock), { title: "Materialen" }, {
                  default: _withCtx(() => [
                    _hoisted_70,
                    _createVNode(_component_a_textarea, {
                      value: _unref(formAnswers).materialNotes,
                      "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_unref(formAnswers).materialNotes) = $event)),
                      disabled: !__props.editable,
                      "auto-size": { minRows: 2 },
                      placeholder: "Eventuele aanvullende notities..."
                    }, null, 8, ["value", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(SectionBlock), { title: "Milieuregels" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_71, [
                      _hoisted_72,
                      _createElementVNode("ul", null, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(environmentRules, (rule) => {
                          return _createElementVNode("li", { key: rule }, _toDisplayString(rule), 1)
                        }), 64))
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(SectionBlock), { title: "Afvalscheiding" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_73, [
                      _hoisted_74,
                      (_unref(isThunnissen))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_75, "Zie pagina 9 van het VGM-document voor meer informatie over afvalscheiding."))
                        : _createCommentVNode("", true),
                      _hoisted_76
                    ]),
                    _createElementVNode("div", _hoisted_77, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(wasteOptions, (stream) => {
                        return _createVNode(_component_a_checkbox, {
                          key: stream.key,
                          checked: _unref(formAnswers).wasteStreams[stream.key],
                          "onUpdate:checked": ($event: any) => ((_unref(formAnswers).wasteStreams[stream.key]) = $event),
                          disabled: !__props.editable,
                          class: "waste-option"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(stream.label), 1)
                          ]),
                          _: 2
                        }, 1032, ["checked", "onUpdate:checked", "disabled"])
                      }), 64))
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(SectionBlock), { title: "Afvalafvoer" }, {
                  default: _withCtx(() => [
                    _hoisted_78,
                    _createVNode(_component_a_textarea, {
                      value: _unref(formAnswers).wasteRemovalNotes,
                      "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_unref(formAnswers).wasteRemovalNotes) = $event)),
                      disabled: !__props.editable,
                      "auto-size": { minRows: 2 },
                      placeholder: "Afspraken omtrent afvalafvoer..."
                    }, null, 8, ["value", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(SectionBlock), { title: "Afvalregistratie" }, {
                  default: _withCtx(() => [
                    _hoisted_79,
                    _createVNode(_component_a_textarea, {
                      value: _unref(formAnswers).wasteRegistrationNotes,
                      "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_unref(formAnswers).wasteRegistrationNotes) = $event)),
                      disabled: !__props.editable,
                      "auto-size": { minRows: 2 },
                      placeholder: "Afspraken omtrent afvalregistratie..."
                    }, null, 8, ["value", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(SectionBlock), { title: "BHV" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_80, [
                      _createElementVNode("p", null, "Informatie over bedrijfshulpverlening staat in de projectintroductiefolder. Namens " + _toDisplayString(_unref(companyName)) + " is altijd minimaal 1 medewerker met BHV-diploma aanwezig. Indien niet wordt er een alternatief georganiseerd.", 1),
                      _hoisted_81
                    ]),
                    _createVNode(_unref(EditableTable), {
                      title: "BHV-middelen",
                      rows: _unref(bhvResources),
                      columns: bhvColumns,
                      editable: __props.editable,
                      onAdd: addBhvResource,
                      onRemove: removeBhvResource
                    }, null, 8, ["rows", "editable"])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(SectionBlock), { title: "Toezicht door leidinggevenden" }, {
                  default: _withCtx(() => [
                    _hoisted_82
                  ]),
                  _: 1
                }),
                _createVNode(_unref(SectionBlock), { title: "Begeleiding door deskundigen" }, {
                  default: _withCtx(() => [
                    _hoisted_83
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_collapse_panel, { key: "section-5" }, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_84, [
                  _createElementVNode("span", _hoisted_85, _toDisplayString((_unref(formAnswers).externalClient ? '4' : '5') + '. VGM-evaluatie (initiatief – oplevering)'), 1),
                  _createVNode(_component_a_tag, {
                    color: _unref(section5Progress) === 100 ? 'success' : 'processing',
                    class: "panel-progress-tag"
                  }, {
                    default: _withCtx(() => [
                      (_unref(section5Progress) === 100)
                        ? (_openBlock(), _createBlock(_unref(CheckOutlined), { key: 0 }))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(_unref(section5Progress)) + "% ", 1)
                    ]),
                    _: 1
                  }, 8, ["color"])
                ])
              ]),
              default: _withCtx(() => [
                _hoisted_86,
                _createVNode(_component_a_row, { gutter: [16, 12] }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, {
                      xs: 24,
                      md: 12
                    }, {
                      default: _withCtx(() => [
                        _hoisted_87,
                        _createVNode(_component_a_input, {
                          value: _unref(formAnswers).evaluationPerformedWith,
                          "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_unref(formAnswers).evaluationPerformedWith) = $event)),
                          disabled: !__props.editable,
                          placeholder: "Namen betrokken personen"
                        }, null, 8, ["value", "disabled"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, {
                      xs: 24,
                      md: 12
                    }, {
                      default: _withCtx(() => [
                        _hoisted_88,
                        _createVNode(_component_a_date_picker, {
                          value: _unref(evaluationDateProxy),
                          "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => (_isRef(evaluationDateProxy) ? (evaluationDateProxy).value = $event : null)),
                          disabled: !__props.editable,
                          format: "DD-MM-YYYY",
                          "value-format": "YYYY-MM-DD",
                          style: {"width":"100%"}
                        }, null, 8, ["value", "disabled"])
                      ]),
                      _: 1
                    }),
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(evaluationQuestions, (question) => {
                      return _createVNode(_component_a_col, {
                        span: 24,
                        key: question.key,
                        class: "mt8"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("label", null, [
                            _createTextVNode(_toDisplayString(question.label) + " ", 1),
                            _hoisted_89
                          ]),
                          _createVNode(_component_a_textarea, {
                            value: _unref(evaluationAnswers)[question.key],
                            "onUpdate:value": ($event: any) => ((_unref(evaluationAnswers)[question.key]) = $event),
                            disabled: !__props.editable,
                            "auto-size": { minRows: 2 },
                            placeholder: "Typ hier de toelichting / evaluatie..."
                          }, null, 8, ["value", "onUpdate:value", "disabled"])
                        ]),
                        _: 2
                      }, 1024)
                    }), 64))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["activeKey"])
      ]),
      _: 1
    }, 8, ["loading"])
  ]))
}
}

})